export const UPLOAD_SOURCES = ["Xero", "CCH", "Breathe", "Other"] as const;
export type UploadSource = (typeof UPLOAD_SOURCES)[number];

export const YEARLESS_SOURCES: readonly UploadSource[] = ["Other"] as const;

export function sourceRequiresYear(source: UploadSource): boolean {
  return !YEARLESS_SOURCES.includes(source);
}

export interface ReportOption {
  value: string;
  label: string;
}

export const REPORTS_BY_SOURCE = {
  Xero: [
    { value: "Plan", label: "Plan" },
    { value: "Alantra_Mappings", label: "Alantra Mappings" },
    { value: "Alantra_Model", label: "Alantra Model" },
    { value: "REG_Topsides", label: "REG Topsides" },
    { value: "Topsides", label: "Topsides" },
    { value: "GL_Mappings", label: "GL Mappings" },
    { value: "Forecast", label: "Forecast" },
  ],
  CCH: [
    { value: "WIPonly", label: "Information WIP Only" },
    { value: "Plan", label: "Utilisation Plan" },
    { value: "AssignmentCodes_Mappings", label: "Assignment Codes Mapping" },
    { value: "Emp_Dept_Mappings", label: "Employee Department Mapping" },
    { value: "AgeBand_Mappings", label: "Age Band Mapping" },
    { value: "RoleCorrections", label: "Employee Role Correction" },
    { value: "Periods_FY_Mapping", label: "Period FY Mapping" },
    { value: "Working_Days_and_Hours", label: "Working Days And Hours" },
    { value: "TailReview_PeriodSelector", label: "Tail Review Period Selector" },
    { value: "EmployeeCategory_Grades", label: "Employee Category Grades" },
  ],
  Breathe: [
    { value: "Plan", label: "Headcount Plan" },
    { value: "Mappings", label: "KPI Mappings" },
    { value: "Actual", label: "Headcount Actual" },
    { value: "ReferenceData", label: "Reference Data" },
  ],
  Other: [
    { value: "CCH_Inclusion_Date", label: "CCH Inclusion Date" },
    { value: "Client_Code_Company", label: "Client Code Company" },
    { value: "Employee_Cezane", label: "Employee Cezane" },
    { value: "Employee_List", label: "Employee List" },
    { value: "Employee_List_Cezane", label: "Employee List Cezane" },
    { value: "Forecast_CCH", label: "Forecast CCH" },
    { value: "Forecast_Karan", label: "Forecast Karan" },
    { value: "KRW_Accountants_Limited_Cube_Opening_Journal", label: "KRW Accountants Limited Cube Opening Journal" },
    { value: "Reforecast_Gross_Margin_Warehouse", label: "Reforecast Gross Margin Warehouse" },
    { value: "UIDs", label: "UIDs" },
  ],
} as const satisfies Record<UploadSource, readonly ReportOption[]>;

export type UploadReport = (typeof REPORTS_BY_SOURCE)[UploadSource][number]["value"];

export const ACCEPTED_UPLOAD_EXTENSIONS = [".csv", ".xlsx", ".xls"] as const;
export const ACCEPTED_UPLOAD_MIME = ".csv,.xlsx,.xls";
